import { createFileRoute } from "@tanstack/react-router"
import { AixContentHeader } from "@aix/ui"
import type { ReactElement } from "react"
import { SeriesList } from "~/components/Admin/SeriesList"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

function AdminContent() {
  return (
    <>
      <CustomHead />
      <div className="container mx-auto space-y-6">
        <AixContentHeader className="px-8 pt-8">
          <h1 className="text-2xl font-bold">Content Management</h1>
        </AixContentHeader>
        <SeriesList />
      </div>
    </>
  )
}

function AdminSeriesWrapper() {
  return (
    <SuperAdminLayout>
      <AdminContent />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/series")({
  component: AdminSeriesWrapper,
})
